// eslint-disable-next-line import/prefer-default-export
export const getImporter = (state) => state.import;
